define('modules/form/checkbox_view',[
  'backbone',
  'jquery',
  '_',

  './form_item_view',
  './convert-form-data',

  'text!./checkbox_template.html',
], function (Backbone, $, _, FormItemView, convertFormData, template) {
  'use strict';
  var View = FormItemView.extend({
    initialize: function (options) {
      _.extend(this, options);

      FormItemView.prototype.initialize.apply(this, options);
      var values = {};
      values[this.model.get('name')] = this.getValues();
      this.dataModel.set(values);
      this.render();
      this.getFrozenOnCreate();
    },

    template: _.template(template),
    events: {
      'change input': 'inputChange',
      'click .label-checkbox': 'clickOnCheckbox',
    },

    //shows frozen icon to title section title if frozen checkbox is checked
    getFrozenOnCreate: function () {
      var checkboxName = this.$('.checkbox-frozen').find(
        '[name="' + this.model.attributes['name'] + '[]"]'
      );
      var options = this.model.get('options');
      setTimeout(function () {
        _.forEach(options, function (option) {
          if (option.state === 'active' && option.action === 'frozen') {
            checkboxName
              .closest('.form-section')
              .find('.icon-frozen')
              .removeClass('icon-frozen-hidden');
          }
        });
      }, 500);
    },

    clickOnCheckbox: function (e) {
      e.preventDefault();
      $(e.currentTarget).parent().find('.input-checkbox').click();
    },

    getValues: function () {
      var values = [];
      if (this.model.get('all')) {
        if (this.model.get('all').state === 'active') {
          values.push(this.model.get('all').value);
          return values;
        }
      }
      _.forEach(this.model.get('options'), function (option) {
        if (option.state === 'active') {
          values.push(option.value);
        }
      });
      return values;
    },

    inputChange: function (e) {
      var target = this.$(e.currentTarget);

      if (this.model.get('all')) {
        //Functionality for this or these
        if (target.is(':checked') && target.data().all) {
          this.$('.or-these').find('[type=checkbox]').attr('checked', false);
          this.$('.or-these').addClass('is-unchecked');
        } else if (target.is(':checked') && !target.data().all) {
          this.$('.js-all-checkbox ').attr('checked', false);
          this.$('.or-these').removeClass('is-unchecked');
          this.$('.pick-this').find('[type=checkbox]').attr('disabled', false);
        }
      }

      //toggle frozen icon to title
      var dataAction = e.currentTarget.attributes['data-action'];
      if (dataAction && dataAction.value === 'frozen') {
        target
          .closest('.form-section')
          .find('.icon-frozen')
          .toggleClass('icon-frozen-hidden');
      }

      this.dataModel.unset(this.model.get('name'));
      var attributes = convertFormData(
        this.$('[name="' + e.target.name + '"]').serializeArray()
      );
      if (!attributes[this.model.get('name')]) {
        attributes[this.model.get('name')] = [];
      }
      this.dataModel.set(attributes);
    },

    render: function () {
      this.$el.html(this.template(this.model.toJSON()));
      return this;
    },
    remove: function () {
      this.$el.off();
      this.$el.remove();
      this.stopListening();
      return this;
    },
  });
  return View;
});

